<template>
  <div class="tag-container md:md-tag-container">
    <h2 class="title md:md-title">For our research:</h2>
    <div v-if="allTagGroups" class="tags grid grid-cols-1">
      <div v-for="tagGroup in allTagGroups" :key="tagGroup.id">
        <div class="grid grid-cols-2">
          <div class="col-span-1">
            {{ tagGroup.name }}
          </div>
          <div class="col-span-1">
            <div v-for="tag in tagGroup.tags" :key="tag.id">
              <div
                class="tag"
                v-bind:class="{ 'selected-tag': isSelected(tag.id) }"
              >
                {{ tag.tag }}
                <input
                    type="checkbox"
                    v-on:click="toggleTag(tag.id)"
                  />
              </div>
              <div v-for="subTag in tag.sub_tags" :key="subTag.id">
                <div
                  class="tag"
                >
                  {{ subTag.tag }}
                  <input
                    type="checkbox"
                    v-on:click="toggleTag(subTag.id)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="continue-button md:md-continue-button" v-on:click="submitTags">
      Continue
    </button>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Tags',
  data() {
    return {
      allTagGroups: [],
      selectedTags: [],
    };
  },
  methods: {
    isSelected(id) {
      return this.selectedTags.indexOf(id) !== -1;
    },
    setTags() {
      axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/api/demographics/tags/`)
        .then((response) => {
          this.allTagGroups = response.data.results;
        })
        .catch((error) => {
          this.$store.commit('setErrorMessage', error);
        });
    },
    submitTags() {
      axios
        .post(
          `${process.env.VUE_APP_BACKEND_URL}/api/sessions/submit-tags/`,
          {
            uuid: this.$store.state.sessionId,
            tags: this.selectedTags,
          },
        )
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit('setView', 'Breathing');
          }
        })
        .catch((error) => {
          this.$store.commit('setErrorMessage', error);
        });
    },
    toggleTag(id) {
      const index = this.selectedTags.indexOf(id);
      if (index !== -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(id);
      }
    },
  },
  mounted() {
    this.setTags();
  },
};
</script>

<style scoped>
.continue-button {
  background-color: #5e5b5c;
  border-radius: 2rem;
  color: #fff;
  font-size: .75rem;
  font-weight: 500;
  padding: .25em 1.75em;
  text-transform: uppercase;
}

.tag-container {
  margin: auto;
  margin-top: 50px;
  max-width: 90vw;
  text-align: left;
}

.selected-tag {
  /* background-color: black;
  color: white; */
}

@responsive {
  .md-continue-button {
    font-size: 1.5rem;
  }

  .md-tag-container {
    font-size: 1.25rem;
    margin-top: 8vh;
    max-width: 70vw;
  }

  .md-title {
    font-size: 2.5rem;
  }
}
</style>
